module.exports = __webpack_public_path__ + "img/banner1_10.b0483f85.png";